function ngBatchIf() {
  /* @ngInject */
  return {
    scope: {},
    compile: function (elm, attrs) {
      // After flattening, Angular will still have the first element
      // bound to the old scope, so we create a temporary marker
      // to store it
      elm.prepend('<div style="display: none"></div>');

      // Flatten (unwrap) the parent
      let children = elm.children();
      elm.replaceWith(children);

      // Add the ng-if to the children
      children.attr('ng-show', attrs.ngBatchIf);

      return {
        post: function postLink(scope, elm) {
          // Now remove the temporary marker
          elm.remove();
        },
      };
    },
  };
}

export default ngBatchIf;
